import type { IDropdownItemOptions } from '../Dropdown.helpers';
import { InputValue } from './Inputvalue';

const ItemOptions = ({ items, hideValue, iconAs, handleItemSelection, CustomItemOption }: IDropdownItemOptions) => (
	<>
		{items.map((item) => (
			<button
				key={`${item.code}_${item.name}`}
				onClick={handleItemSelection(item)}
				className='dropdown_content_item_options_item'
				data-testid={`country-button-${item.code}`}
				title={item.name}
				name={item.name}
			>
				{!CustomItemOption ? (
					<>
						<span className='dropdown_content_item_options_item_name'>{item.name}</span>

						{!hideValue && <span className='dropdown_content_item_options_item_code'>{item.value}</span>}
						<span className='dropdown_content_item_options_item_flag'>
							<InputValue
								icon={item.icon}
								iconAs={iconAs}
							/>
						</span>
					</>
				) : (
					<CustomItemOption item={item} />
				)}
			</button>
		))}
	</>
);

export default ItemOptions;
